<!--
  <div class="etiqueraDesarrollo" *ngIf="!envi">Modo Desarrollo</div>
-->

<router-outlet></router-outlet>
